import { recommendationService } from '../../helpers/services/productRecommendation.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, sessionHelper } from '@/utils'
import { SESSION } from "@/constants";
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUCT_RECOMMENDATION_MODULE = 'productRecommendation';

// define action 
export const GET_ALL_PRODUCT_RECOMMENDATIONS = 'getAllProductRecommendations';
export const GET_PRODUCT_RECOMMENDATION = 'getProductRecommendation';
export const UPDATE_PRODUCT_RECOMMENDATION = 'updateProductRecommendation';
export const CREATE_PRODUCT_RECOMMENDATION = 'createProductRecommendation';
export const UPDATE_PRODUCT_RECOMMENDATION_STATUS = 'updateProductRecommendationStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCT_RECOMMENDATIONS_REQUEST = "getAllProductRecommendations";
const GET_PRODUCT_RECOMMENDATION_REQUEST = "getProductRecommendation";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCT_RECOMMENDATIONS]({ commit }, { filter }) {
        await recommendationService
            .getAllRecommendations(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCT_RECOMMENDATIONS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT_RECOMMENDATION]({ commit }, { id }) {
        recommendationService
            .getRecommendation(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_RECOMMENDATION_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_RECOMMENDATION]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        recommendationService
            .updateRecommendation(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.recommendation')]);
                    if (isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_RECOMMENDATION]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        recommendationService
            .createRecommendation(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.createXSuccess", [i18n.t('module.recommendation')]);
                    if (isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_RECOMMENDATION_STATUS]({ dispatch }, { filter, data }) {
        recommendationService
            .updateRecommendationStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCT_RECOMMENDATIONS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state, isCloseWhenSuccess) {
        state.status = {};
        if (isCloseWhenSuccess == false) {
            router.push({ name: "Product-recommendation-listing" });
        }
        else {
            sessionHelper.clearSearch(SESSION.PRODUCT_SPECIAL_SEARCH)
        }
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCT_RECOMMENDATIONS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                remark: o.remark,
                status: o.status,
                product: o.product,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRODUCT_RECOMMENDATION_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            remark: o.remark,
            product: o.product,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            productID: o.product != null ? {
                value: o.product.uuid,
                text: o.product.name
            } : '',
            status: o.status == true ?
                {
                    value: o.status,
                    text: "Approved"
                } :
                {
                    value: o.status,
                    text: "Pending"
                },
            crops: Array.isArray(o.crops) && o.crops.length > 0
                ? o.crops.map(crop => ({
                    name: crop.name,
                    pestControls: Array.isArray(crop.pest_controls)
                        ? crop.pest_controls.map(pest => ({
                            pestControl: pest.pest_control,
                            rate: pest.rate,
                        }))
                        : [{ pestControl: '', rate: 0 }],
                }))
                : [{
                    name: '',
                    pestControls: [{ pestControl: '', rate: 0 }]
                }],
        }

    }
}


